module.exports = __webpack_public_path__ + "img/C04TechSpearmanS_ua.bad05dfd.webp";